import { BellIcon, InboxIcon, MessageSquare, Quote } from "lucide-react";

export type NotificationData = {
  header: string;
  content: string;
  cta: string;
  icon?: string;
};

export function NotificationIcon({
  data,
  eventName,
}: {
  data: NotificationData;
  eventName: string;
}) {
  const className = "size-5 text-dark-600 mt-0.5 shrink-0 overflow-hidden";
  if (data.icon) {
    return <img src={data.icon} alt={data.header} className={className} />;
  } else {
    if (eventName.startsWith("message:")) {
      return <MessageSquare className={className} />;
    } else if (eventName.startsWith("request:")) {
      return <InboxIcon className={className} />;
    } else if (eventName.startsWith("quote:")) {
      return <Quote className={className} />;
    } else {
      return <BellIcon className={className} />;
    }
  }
}
